import React from 'react';
import { Alert, Box, Chip, Stack, Tooltip, Typography } from '@mui/material';
import { formatNuf } from '../../utils/formatNuf';
import { formatCustomerName } from '../../utils/formatCustomerName';

const currency = value => new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(value || 0));
export const confidenceLabel = suggestion => ({ high: 'Alta', medium: 'Media', low: 'Bassa' }[suggestion?.confidenceLevel] || 'Da verificare');
export const parseSuggestions = value => { try { const result = typeof value === 'string' ? JSON.parse(value) : value; return Array.isArray(result) ? result : []; } catch { return []; } };

export default function PostalSlipMatchSummary({ slip, detail = false }) {
  const summary = slip.accounting;
  // Registered records take precedence over OCR state, stale suggestions and legacy invoice_id.
  if (summary?.status === 'registered') return <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary">Registrato</Typography>
    {summary.assignments.map(item => <Box key={`${item.tipo}-${item.source_id}`}>
      <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
        <Chip size="small" color="success" label={item.tipo === 'fattura' && item.invoice ? `Fatt. ${formatNuf(item.invoice.sezionale, item.invoice.nuf)}` : 'Acconto'} />
        <Chip size="small" color="success" variant="outlined" label={currency(item.amount)} />
        <Tooltip title={formatCustomerName(item.customer, '')}><Chip size="small" label={formatCustomerName(item.customer, 'Cliente non disponibile')} /></Tooltip>
      </Stack>
    </Box>)}
    {summary.verified_by_operator && <Typography variant="caption" color="success.main">Verificato dall’operatore</Typography>}
    {summary.remaining_amount > 0.01 && <Typography variant="caption" color="warning.main">Rimanenza: {currency(summary.remaining_amount)}</Typography>}
  </Stack>;
  if (['missing','ambiguous'].includes(summary?.status) || (slip.match_status === 'confirmed' && !summary)) {
    return <Alert severity="warning">Assegnazioni da verificare</Alert>;
  }
  const suggestions = parseSuggestions(slip.suggestions);
  const best = suggestions[0];
  if (!best) return <Chip size="small" variant="outlined" label={slip.ocr_status === 'failed' ? 'Errore lettura' : 'Da verificare'} />;
  return <Stack spacing={0.5}>
    <Typography variant="caption" color="text.secondary">Suggerito · Affidabilità {confidenceLabel(best).toLowerCase()}</Typography>
    <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap>
      <Chip size="small" color="warning" variant="outlined" label={best.invoiceNum ? `Fatt. ${best.invoiceNum}` : 'Acconto'} />
      {best.customerName && <Chip size="small" variant="outlined" label={best.customerName} />}
    </Stack>
    {(best.warnings?.length > 0 || best.isGiaPagata || best.customerMismatch) && <Typography variant="caption" color="warning.main">
      {best.isGiaPagata ? 'Fattura già saldata' : best.customerMismatch ? 'Cliente discordante' : 'Dati da verificare sull’immagine'}
    </Typography>}
    {detail && (best.reasons || []).map((reason,i) => <Typography key={i} variant="caption">{reason}</Typography>)}
  </Stack>;
}
